import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Wrapper = styled.div``;

const Title = styled.div``;

function QuickCategory() {
  return (
    <Wrapper>
      <h1>aadd</h1>
      <h1>aadd</h1>
      <Title>Truy cập nhanh danh mục</Title>
    </Wrapper>
  );
}

export default QuickCategory;
